<template>
  <div>
    <div>
      <div v-if="!loading">
        <div v-show="Subscriptions.length > 0">
          <h1 v-if="!Admin" class="title-2">Payment Details</h1>
          <b-table :data="Subscriptions">
            <b-table-column v-if="Admin" field="UserName" label="User's Name" v-slot="props">
              {{ props.row.UserName }}
            </b-table-column>
            <b-table-column v-if="Admin" field="Organization" label="Organization Name" v-slot="props">
              {{ props.row.Organization }}
            </b-table-column>
            <b-table-column field="Name" label="Product" v-slot="props">
              {{props.row.Name || 'Carbon Calculator Access'}}
              <!--<div>
                <b-button size="is-small" :disabled="props.row.upgrading" @click="Upgrade(props.row)" v-if="HasUpgrade(props.row.PlanId)">{{UpgradePrefix(props.row.PlanId)}} to {{GetUpgradeName(props.row.PlanId)}}</b-button>
                <div v-show="props.row.upgraded">
                  Please refresh the page to see changes.
                </div>
              </div>-->
            </b-table-column>
            <b-table-column field="Amount" label="Amount (USD)" v-slot="props">
              {{FormatCurrency(props.row.LastPaymentAmount)}}
            </b-table-column>
            <b-table-column field="Status" label="Status" v-slot="props">
              <b-tooltip type="is-primary is-light" :active="props.row.Status === 'CANCELLED'">
                <template v-slot:content>
                  <span>
                    {{props.row.CancelReason}}
                  </span>
                </template>
                {{props.row.Status}}
              </b-tooltip>
            </b-table-column>
            <b-table-column field="LastPaymentOn" label="Last Payment" v-slot="props">
              {{$moment.utc(props.row.LastPaymentOn) | moment("M/DD/YYYY")}}
            </b-table-column>
            <b-table-column field="NextPaymentOn" label="Next Payment" v-slot="props">
              <div v-show="props.row.Status !== 'CANCELLED'">
                <div>
                  <b-button type="is-danger" :disabled="props.row.cancelling" :loading="props.row.cancelling" @click="TryCancelSubscription(props.row)">Cancel</b-button>
                </div>
                Renews on {{$moment.utc(props.row.NextPaymentOn) | moment("M/DD/YYYY")}}
              </div>
            </b-table-column>
          </b-table>
        </div>
      </div>
      <div class="my-5" v-else>
        <b-skeleton width="80%" animated></b-skeleton>
        <b-skeleton width="80%" animated></b-skeleton>
      </div>
    </div>
    <div v-if="!Admin" v-show="Subscriptions.length > 0">
      <a href="https://paypal.com" target="_blank">Update payment information on PayPal</a>&nbsp;<b-icon icon="external-link"></b-icon>
    </div>
  </div>
</template>
<script>
  import products from "@/products";
  export default {
    data() {
      return {
        subscriptions: [],
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      data: {
        type: Array,
        default: () => { return undefined; }
      },
      Admin: Boolean
    },
    watch: {
      data: {
        handler(n, o) {
          if (n !== o) {
            this.subscriptions = n;
          }
        },
        deep: true
      }
    },
    computed: {
      Subscriptions() {
        return this.subscriptions.map(x => {
          return {
            Id: x.Id,
            Name: x.Name,
            CreatedOn: x.CreatedOn,
            Status: x.Details.status,
            CancelReason: x.Details.status_change_note,
            CurrencyCode: x.Details.billing_info.last_payment.amount.currency_code,
            LastPaymentOn: x.Details.billing_info.last_payment.time,
            LastPaymentAmount: x.Details.billing_info.last_payment.amount.value,
            NextPaymentOn: x.Details.billing_info.next_billing_time,
            Subscriber: x.Details.subscriber.email_address,
            TransactionId: x.TransactionId,
            SubscriptionId: x.SubscriptionId,
            PlanId: x.Details.plan_id,
            UserName: x.UserName,
            Organization: x.Organization
          }
        })
      },
    },
    methods: {
      GetUpgradeName(planId) {
        const product = products.GetProductByPlan(planId);
        return product.upgradeName;
      },
      UpgradePrefix(planId) {
        const product = products.GetProductByPlan(planId);
        return product.prefix;
      },
      HasUpgrade(planId) {
        const product = products.GetProductByPlan(planId);
        return !!product.upgrade;
      },
      FormatCurrency(num) {
        return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(num);
      },
      TryCancelSubscription(row) {
        this.$buefy.dialog.confirm({
          message: "Are you sure you want to cancel this subscription?",
          type: 'is-danger',
          cancelText: "Close",
          confirmText: "Cancel",
          onConfirm: async () => { await this.CancelSubscription(row); }
        });
      },
      async CancelSubscription(row) {
        row.cancelling = true;
        try {
          var response = await this.$http.get("/api/payment/unsubscribe/" + row.SubscriptionId);
          if (response.data) {
            //this.$set(this.subcriptions, row.Id, 'CANCELLED');
            location.reload();
            this.$buefy.toast.open("Successfully cancelled subscription.");
          }
          else
            this.$error("Failed to cancel subscription");

          row.cancelling = false;
          return response;
        }
        catch (err) {
          row.cancelling = false;
          console.error(err);
          return Promise.reject(err);
        }
      },
      GetPlanUpgrade(planId) {
        const product = products.GetProductByPlan(planId);
        return product.upgrade;
      },
      async Upgrade(row) {
        const planId = this.GetPlanUpgrade(row.PlanId);
        row.upgrading = true;
        try {
          var response = await this.$http.post("/api/payment/upgrade/" + row.SubscriptionId, { planId: planId });
          if (response.data && response.data.name === "UNPROCESSABLE_ENTITY") {
            this.$buefy.toast.open({
              duration: 10000,
              message: "Failed to upgrade plan.",
              type: "is-danger"
            });
            row.upgrading = false;
            return;
          }
          const approvalLink = response.data.links.filter(x => x.rel === "approve")[0];
          window.open(approvalLink.href, "_blank");
          row.upgrading = false;
          row.upgraded = true;
          return response;
        }
        catch (err) {
          row.upgrading = false;
          console.error(err);
          return Promise.reject(err);
        }
      }
    },
    created() {
      if (this.data)
        this.subscriptions = this.data
    },
    mounted() {

    }
  }
</script>
